import React, {Suspense} from "react";
import {createRoot} from "react-dom/client";
import {useTranslation} from "react-i18next";
import Card from "../../molecules/Card";
import {BlogOverviewType} from "../../../helpers/loadBlogs";

class BlogOverviewContent {
  constructor(element: HTMLElement, blog: BlogOverviewType) {
    const root = createRoot(element);
    root.render(
      <Suspense fallback={null}>
        <BlogOverviewCard blog={blog} />
      </Suspense>,
    );
  }
}

const BlogOverviewCard: React.FC<{blog: BlogOverviewType}> = ({blog}) => {
  const {t} = useTranslation();
  const {image, categoryName, headline, text, authorImage, author, link} = blog;
  const authorName = author.split(" ")[0];

  return (
    <Card
      image={image}
      categoryName={categoryName}
      headline={headline}
      shortText={text}
      authorImage={authorImage}
      authorName={authorName}
      linkText={t("general.readNow")}
      linkUrl={link}
      linkTitle={t("general.open--title", {title: headline})}
    />
  );
};
export default BlogOverviewContent;
